import Vue from 'vue'
import Vuex from 'vuex'
// import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'
// import cart from './mudules/cart'

Vue.use(Vuex)

// 存放着组件中信息的状态
const state = {
  count:localStorage.getItem('carCount')?JSON.parse(localStorage.getItem('carCount')):0,
  goodsCarList:[],
  num:localStorage.getItem('Num')?JSON.parse(localStorage.getItem('Num')):0,
  goodsCounts:localStorage.getItem('carNum')?JSON.parse(localStorage.getItem('carNum')):0,
  clientid:sessionStorage.getItem('clientId')?JSON.parse(sessionStorage.getItem('clientId')):null,

  goClientId:sessionStorage.getItem('goclientid')?JSON.parse(sessionStorage.getItem('goclientid')):null,
  editData:"sessionStorage.getItem('addrEdit')?JSON.parse(sessionStorage.getItem('addrEdit')):null,",
  orderPay:'',
  producelist:[],
  allcount:localStorage.getItem('allcount')?JSON.parse(localStorage.getItem('allcount')):null,
  navdata:sessionStorage.getItem('navData')?JSON.parse(sessionStorage.getItem('navData')):null,
  typeGrade:sessionStorage.getItem('grade')?JSON.parse(sessionStorage.getItem('grade')):null,
  typeName:sessionStorage.getItem('typename')?JSON.parse(sessionStorage.getItem('typename')):null,
  typeId:sessionStorage.getItem('Id')?JSON.parse(sessionStorage.getItem('Id')):null,
  UserInfo:sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')):null,
  // getGoodsData:[],
  // pay:localStorage.getItem('orderlist')?JSON.parse(localStorage.getItem('orderlist')):null,
  produces:localStorage.getItem('orderlist')?JSON.parse(localStorage.getItem('orderlist')):null,
  // curuser:localStorage.getItem('curUser')?JSON.parse(localStorage.getItem('curUser')):null
};

export default new Vuex.Store({
  state,
  mutations,
  // actions,
  getters,
  // modules: {
  //   cart
  // }
})



// WEBPACK FOOTER //
// ./src/store/index.js